import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Inputs() {
  return <OperationalResource title="Inputs &amp; Forecasts" resource="inputs" />;
}
